import React from 'react';
import { default as ChatComposer, type ChatComposerProps } from './ChatComposer';
import { default as ChatComposerChip, type ChatComposerChipProps } from './ChatComposerChip';
import { default as ChatContext, type ChatContextProps } from './ChatContext';
import { default as ChatContextMeter, type ChatContextMeterProps } from './ChatContextMeter';
import { default as ChatHeader, type ChatHeaderProps } from './ChatHeader';
import { default as ChatMessage, type ChatMessageProps } from './ChatMessage';
import { default as ChatModelPicker, type ChatModelPickerProps } from './ChatModelPicker';
import { type ChatProps, default as ChatRoot } from './ChatRoot';
import { default as ChatSuggestion, type ChatSuggestionProps } from './ChatSuggestion';
import { default as ChatThinking, type ChatThinkingProps } from './ChatThinking';
import { default as ChatThread, type ChatThreadProps } from './ChatThread';
import { default as ChatToolCall, type ChatToolCallProps } from './ChatToolCall';

export type {
    ChatFeedback,
    ChatMessageStatus,
    ChatMessageUsage,
    ChatMessageVariant,
    ChatRole,
} from './ChatMessage';
export type { ChatToolCallStatus } from './ChatToolCall';
export type { ChatModelOption, ChatModelSubOption } from './ChatModelPicker';
export type { ChatContextItem } from './ChatContext';
export type {
    ChatComposerChipProps,
    ChatComposerProps,
    ChatContextMeterProps,
    ChatContextProps,
    ChatHeaderProps,
    ChatMessageProps,
    ChatModelPickerProps,
    ChatProps,
    ChatSuggestionProps,
    ChatThinkingProps,
    ChatThreadProps,
    ChatToolCallProps,
};

interface ChatComponent extends React.FC<ChatProps> {
    Header: React.FC<ChatHeaderProps>;
    Thread: React.FC<ChatThreadProps>;
    Message: React.FC<ChatMessageProps>;
    ToolCall: React.FC<ChatToolCallProps>;
    Thinking: React.FC<ChatThinkingProps>;
    Composer: React.FC<ChatComposerProps>;
    ComposerChip: React.FC<ChatComposerChipProps>;
    Context: React.FC<ChatContextProps>;
    ContextMeter: React.FC<ChatContextMeterProps>;
    ModelPicker: React.FC<ChatModelPickerProps>;
    Suggestion: React.FC<ChatSuggestionProps>;
}

const Chat = ChatRoot as ChatComponent;

Chat.Header = ChatHeader;
Chat.Thread = ChatThread;
Chat.Message = ChatMessage;
Chat.ToolCall = ChatToolCall;
Chat.Thinking = ChatThinking;
Chat.Composer = ChatComposer;
Chat.ComposerChip = ChatComposerChip;
Chat.Context = ChatContext;
Chat.ContextMeter = ChatContextMeter;
Chat.ModelPicker = ChatModelPicker;
Chat.Suggestion = ChatSuggestion;

export default Chat;
export { Chat };
